(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["withdrawal-request"] && !Shopify.designMode) return;
  try {
    (() => {
const dialog=document.getElementById('withdrawal-dialog');
if(!dialog)return;
let trigger;
function openDialog(){if(!dialog.open)dialog.showModal();}
document.addEventListener('click',event=>{
const link=event.target.closest('[data-withdrawal-open]');
if(link){event.preventDefault();trigger=link;openDialog();}
});
dialog.querySelector('.withdrawal-close').addEventListener('click',()=>dialog.close());
dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
dialog.addEventListener('close',()=>{if(trigger)trigger.focus();});
const form=dialog.querySelector('form');
form.addEventListener('submit',()=>{try{sessionStorage.setItem('withdrawal-pending','1');}catch{}});
let pending=false;try{pending=sessionStorage.getItem('withdrawal-pending')==='1';}catch{}
const outcome=dialog.querySelector('[data-withdrawal-success],[data-withdrawal-errors]');
if((pending&&outcome)||location.hash==='#WithdrawalForm'||location.hash==='#withdrawal-dialog'){openDialog();if(outcome){outcome.setAttribute('tabindex','-1');outcome.focus();try{sessionStorage.removeItem('withdrawal-pending');}catch{}}}
})();
  } catch(e) { console.error(e); }
})();

})();
